module.exports = __webpack_public_path__ + "img/img3.c5af51d8.png";